<template>
  <div>
    <v-banner>
      <h2 class="font-weight-black primary--text">DATA RELAWAN</h2>
      <CmodalAdd />
    </v-banner>

    <div class="mt-5">
      <div class="mb-n2">
        <v-row dense>
          <v-col cols="12" md="10">
            <v-select
              v-model="bulan"
              :items="refbulan"
              item-value="id"
              item-text="nama"
              solo
              label="Filter Perkembangan Perbulan"
              @change="cbulan"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-card class="pa-3 font-weight-black" color="utama" dark>
              Total Relawan: {{ total }}
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-card class="pa-2" outlined>
        <Cpekembangan />
      </v-card>
    </div>

    <div class="my-5">
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <div class="my-5 pb-12">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="data"
          :loading="loading"
        >
          <template v-slot:top>
            <!-- <CmodalDetail />
            <CmodalEdit />
            <CmodalHapus /> -->
          </template>

          <template v-slot:[`item.nomor`]="{ item }">
            {{
              data
                .map(function (x) {
                  return x.relawan_id;
                })
                .indexOf(item.relawan_id) + 1
            }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon color="primary" @click="hapus(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import CmodalAdd from "@/components/relawan/modal_add";
import Cpekembangan from "@/components/chart/relawan/data/perkembangan";

import refreshView from "@/store/relawan/view";
import chart_state from "@/store/chart/relawan/data/perkembangan";

export default {
  components: {
    CmodalAdd,
    // CmodalEdit,
    // CmodalDetail,
    // CmodalHapus,

    Cpekembangan,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    alertMassage: {
      get() {
        return refreshView.state.alertMassage;
      },
    },

    success: {
      get() {
        return refreshView.state.success;
      },
      set(value) {
        refreshView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return refreshView.state.alertBerhasil;
      },
      set(value) {
        refreshView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return refreshView.state.alertGagal;
      },
      set(value) {
        refreshView.commit("gagalAlert", value);
      },
    },
  },

  watch: {
    refresh() {
      this.getData();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  data: () => ({
    session: "",
    search: "",
    loading: true,

    bulan: parseInt(new Date().toISOString().substr(5, 2)),
    total: 0,

    kecamatan: [],
    data: [],

    refbulan: [
      {
        id: 1,
        nama: "Januari",
      },
      {
        id: 2,
        nama: "Februari",
      },
      {
        id: 3,
        nama: "Maret",
      },
      {
        id: 4,
        nama: "April",
      },
      {
        id: 5,
        nama: "Mei",
      },
      {
        id: 6,
        nama: "Juni",
      },
      {
        id: 7,
        nama: "Juli",
      },
      {
        id: 8,
        nama: "Agustus",
      },
      {
        id: 9,
        nama: "September",
      },
      {
        id: 10,
        nama: "Oktober",
      },
      {
        id: 11,
        nama: "November",
      },
      {
        id: 13,
        nama: "Desember",
      },
    ],

    headers: [
      {
        text: "No",
        value: "nomor",
        width: "50px",
        align: "center",
        sortable: false,
      },
      { text: "Nama", align: "start", value: "relawan_nama" },
      { text: "Kabupaten / Kota", align: "start", value: "kab_nama" },
      { text: "Kecamatan", align: "start", value: "kec_nama" },
      { text: "Desa / Kelurahan", align: "start", value: "desa_nama" },
      {
        text: "Action",
        align: "center",
        value: "action",
        width: "100px",
        sortable: false,
      },
    ],
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
    this.getData();
    this.getPerkembangan();
  },

  methods: {
    getData() {
      this.axios
        .get(process.env.VUE_APP_API + "relawan", {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((res) => {
          refreshView.commit("refreshData", false);
          this.data = res.data.data;
          this.total = res.data.count;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response.status);
        });
    },

    getPerkembangan() {
      let url = process.env.VUE_APP_API + "relawan/pekembangan/" + this.bulan;
      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((res) => {
          refreshView.commit("refreshData", false);
          chart_state.commit("viewData", res.data.data);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response.status);
        });
    },

    cbulan() {
      let url = process.env.VUE_APP_API + "relawan/pekembangan/" + this.bulan;
      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((res) => {
          chart_state.commit("viewData", res.data.data);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response.status);
        });
    },

    hapus(value) {
      console.log(value);
    },
  },
};
</script>
